import React, { FunctionComponent, useState } from 'react';
import { AnalysisResultsForCheckup, CheckupRequestInfo } from '@companion-professional/dctypes';
import { Section } from '../../components/Section';
import { RequestedItem } from './RequestedItem';
import { ItemSelector } from './ItemSelector';

interface ItemViewerProps {
  checkup: CheckupRequestInfo;
  mlForCheckup?: AnalysisResultsForCheckup;
}

// ItemViewer is a component that displays the requested item for a checkup.  If there are multiple items, then some
// selections will be displayed on the right side to allow the user to select which item to view.  Currently, we only
// request one item per checkup (a video), but this component is designed to handle multiple items in the future.
// Note the UI is pretty basic, and will likely be improved in the future (like adding thumbnails and a better
// description and/or date/time).
export const ItemViewer: FunctionComponent<ItemViewerProps> = ({ checkup, mlForCheckup }) => {
  const [currentItemId, setCurrentItemId] = useState<string | null>(checkup?.requests?.[0]?.item_id || null);

  return (
    <Section className="flex flex-1 flex-row items-stretch gap-4 py-4">
      <div className="flex h-full flex-1 flex-col gap-4">
        {currentItemId ? (
          <RequestedItem
            requestedItem={checkup.requests.find((req) => req.item_id === currentItemId)}
            mlForItem={mlForCheckup?.items?.[currentItemId]}
          />
        ) : null}
      </div>

      {/* Only show the ItemSelector component if there are more than one item (e.g. multiple videos for a single
      checkup */}
      {checkup?.requests?.length > 1 ? (
        <ItemSelector currentItemId={currentItemId} setCurrentItemId={setCurrentItemId} checkup={checkup} />
      ) : null}
    </Section>
  );
};
